import { sellerConstants } from '../../../_constants/seller.constants';
import { creditService } from '../../../_services';
import { creditListActions } from './creditlist.actions';

export const sellCreditAction = {
    addData
};

function addData(data) {

    return dispatch => {
        dispatch(request());
        creditService.sellCredit(data)
            .then(
                response => {
                    dispatch(creditListActions.getCreditList(data.seller_id));
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_SELL_CREDITS } }
    function success(data) { return { type: sellerConstants.RECEIVE_SELL_CREDITS, data } }
    function failure(error) { return { type: sellerConstants.SELL_CREDITS_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerCredit/sellCredit.actions.js